import { render, staticRenderFns } from "./EditShowHeader.vue?vue&type=template&id=de668e6c&"
import script from "./EditShowHeader.vue?vue&type=script&lang=js&"
export * from "./EditShowHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports